import dynaForms from '@elab/core/utils/dynaForms';

const getSelectors = storeName => {
    const dynaSelectors = dynaForms.getSelectors(storeName);

    const getRegistrationForm = state => dynaSelectors.getStore(state);
    const getRegisteredUser = state => getRegistrationForm(state).registeredUser;
    const isAgeVerified = state => getRegistrationForm(state).isAgeVerified;
    const getAgeVerification = state =>
        (
            ((getRegistrationForm(state) && getRegistrationForm(state).data.dateOfBirth) || {})
                .dialogConstraints || []
        ).find(dialogConstraint => dialogConstraint.type === 'ageVerification');
    const getDataFieldValues = (state, fieldName) =>
        (dynaSelectors.getDataField(state, fieldName) || {}).values;
    const getUserMobile = state =>
        dynaSelectors.getDataField(state, 'mobileNumber') &&
        dynaSelectors.getDataField(state, 'mobileNumber').value;
    const isLoyaltyPhone = state => getRegistrationForm(state).isLoyaltyPhone;

    return {
        ...dynaSelectors,
        getRegisteredUser,
        getAgeVerification,
        isAgeVerified,
        getDataFieldValues,
        getUserMobile,
        isLoyaltyPhone,
    };
};

export default getSelectors;
